import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25fe81b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-xs",
  "data-cy": "pdf-page-header"
}
const _hoisted_2 = { class: "flex justify-between py-1" }
const _hoisted_3 = {
  class: "font-semibold",
  "data-cy": "header-titel"
}
const _hoisted_4 = { "data-cy": "header-seite" }
const _hoisted_5 = {
  class: "top-header mb-1 pb-1",
  "data-cy": "header-data"
}
const _hoisted_6 = {
  key: 0,
  class: "chapter mt-2",
  "data-cy": "header-breadcrumbs"
}
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass('active')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageCounter = _resolveComponent("PageCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("hzba.pdf.acon", 1, { locale: _ctx.lang })) + " " + _toDisplayString(_ctx.t("hzba.pdf.kopfzeileEnsimimav")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PageCounter)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("hzba.pdf.ensimimav.objekt", 1, { locale: _ctx.lang })) + ": " + _toDisplayString(_ctx.immobilie.strasse) + ", " + _toDisplayString(_ctx.immobilie.plz) + " " + _toDisplayString(_ctx.immobilie.stadt) + " / " + _toDisplayString(_ctx.t("hzba.pdf.datum", 1, { locale: _ctx.lang })) + ": " + _toDisplayString(_ctx.moment(_ctx.hzba.begehungsdatum).format("DD.MM.YYYY")) + " / " + _toDisplayString(_ctx.t("hzba.pdf.auftraggeber", 1, { locale: _ctx.lang })) + ": " + _toDisplayString(_ctx.getVerwalterLabel() || "-"), 1),
    (_ctx.showChapters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.crumbsBeginning), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.crumbsMiddle), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.crumbsEnd), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}